export default class SavingsGas {
  p_fijo_actual: number;
  p_gas: number;
  dias: number;
  energia: number;
  p_gas_podo: number;
  p_fijo_podo: number;

  constructor(
    p_fijo_actual: number,
    p_gas: number,
    dias: number,
    energia: number,
    p_gas_podo: number,
    p_fijo_podo: number
  ) {
    this.p_fijo_actual = p_fijo_actual;
    this.p_gas = p_gas;
    this.dias = dias;
    this.energia = energia;
    this.p_gas_podo = p_gas_podo;
    this.p_fijo_podo = p_fijo_podo;
  }
}
